export const SUBCONTRACTORS_MISSING_IBAN_STATUS = 'MISSING_IBAN';
